import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "header-title" };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "header-icon-slot" };
const _hoisted_4 = { class: "flex flex-col header-context-menu p-1" };
const _hoisted_5 = {
    key: 1,
    class: "header-title-container"
};
const _hoisted_6 = { class: "header-title" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnDraggableWrapper"], {
        ref: "headerRow",
        modelValue: $setup.localColumns,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.localColumns) = $event)),
        "prevent-on-filter": true,
        clone: (original) => ({ ...original }),
        animation: 150,
        draggable: ".draggable-column-header",
        tag: "tr",
        filter: ".static-column-header",
        class: "draggable-columns-container",
        onStart: $setup.onDragStart,
        onUpdate: $setup.onDragUpdate,
        onEnd: $setup.onDragEnd
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (column) => {
                return (_openBlock(), _createElementBlock("th", {
                    key: column.key,
                    class: _normalizeClass(["v-data-table__td v-data-table-column--align-start v-data-table__th custom-table-header", [$setup.getHeaderClass(column), { 'secondary-header-variant': $setup.props.variant === 'secondary', 'borderless-header-variant': $setup.props.variant === 'borderless', 'is-sorted': $setup.isColumnSorted(column), 'col-hovered': $setup.hoveredColumnKey === column.key }]]),
                    style: _normalizeStyle({ minWidth: column.minWidth, width: column.minWidth })
                }, [
                    ($props.dense && $props.allowAdding && column.value === 'actions')
                        ? (_openBlock(), _createBlock($setup["EnButton"], {
                            key: 0,
                            "static-id": $setup.buildAddId,
                            variant: "default",
                            width: "100%",
                            class: "add-button",
                            onClick: $props.addItem
                        }, {
                            default: _withCtx(() => [
                                _createVNode($setup["Plus"], {
                                    size: "16",
                                    class: "text-background"
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["static-id", "onClick"]))
                        : _createCommentVNode("v-if", true),
                    (!$setup.columnIsSelection(column) && !$setup.columnIsActions(column))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["v-data-table-header__content justify-space-between", [column.sortable ? 'cursor-pointer' : 'cursor-default', { 'menu-open': !!$setup.menuVisibility[column.key] }, { 'header-item': !column.isStatusCell }]])
                        }, [
                            ($setup.columnHasMenu(column))
                                ? (_openBlock(), _createBlock($setup["EnMenu"], {
                                    key: 0,
                                    ref_for: true,
                                    ref: el => $setup.setComponentRef(el, column.key),
                                    class: "p-0 z-2500",
                                    "close-on-content-click": true,
                                    disabled: $setup.props.loading,
                                    transition: "slide-y-transition",
                                    "offset-y": "",
                                    "show-on-hover": "",
                                    "onUpdate:open": (value) => $setup.handleMenuVisibilityUpdate(column.key, value)
                                }, {
                                    trigger: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["header-title-container", { 'menu-open': !!$setup.menuVisibility[column.key] }])
                                        }, [
                                            _createElementVNode("div", _hoisted_1, [
                                                ($setup.hasSlot(column))
                                                    ? _renderSlot(_ctx.$slots, $setup.slotName(column), {}, undefined, true, 0)
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(column.title), 1 /* TEXT */))
                                            ]),
                                            _createElementVNode("div", _hoisted_3, [
                                                _createVNode(_Transition, { name: "icon-scale" }, {
                                                    default: _withCtx(() => [
                                                        ($setup.isColumnSorted(column) && !$setup.menuVisibility[column.key])
                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                class: "sort-icon",
                                                                key: $setup.getSortDirection(column)
                                                            }, [
                                                                _createVNode($setup["EnIcon"], { size: "16" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString($setup.getSortDirection(column) === $setup.ColumnSortDirections.Ascending ? 'mdi-arrow-up' : 'mdi-arrow-down'), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1024 /* DYNAMIC_SLOTS */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */),
                                                _createVNode($setup["EnIcon"], {
                                                    class: "ellipsis-icon",
                                                    size: "16"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                            _createTextVNode("mdi-dots-horizontal", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                })
                                            ])
                                        ], 2 /* CLASS */)
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                            ($setup.columnCanBeSorted(column) && (!$setup.isColumnSorted(column) || $setup.getSortDirection(column) === $setup.ColumnSortDirections.Descending))
                                                ? (_openBlock(), _createBlock($setup["EnMenuItem"], {
                                                    key: 0,
                                                    "static-id": $setup.buildId('sort-column-ascending', column.key),
                                                    onClick: () => { $setup.sortAsc(column); $setup.ensureMenuKey(column.key); $setup.closeMenu(column.key); }
                                                }, {
                                                    icon: _withCtx(() => [
                                                        _createVNode($setup["ArrowUp"], { size: 15 })
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" " + _toDisplayString($setup.t('common.buttons.sortDirections.ascending')), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["static-id", "onClick"]))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.columnCanBeSorted(column) && (!$setup.isColumnSorted(column) || $setup.getSortDirection(column) === $setup.ColumnSortDirections.Ascending))
                                                ? (_openBlock(), _createBlock($setup["EnMenuItem"], {
                                                    key: 1,
                                                    "static-id": $setup.buildId('sort-column-descending', column.key),
                                                    onClick: () => { $setup.sortDesc(column); $setup.ensureMenuKey(column.key); $setup.closeMenu(column.key); }
                                                }, {
                                                    icon: _withCtx(() => [
                                                        _createVNode($setup["ArrowDown"], { size: 15 })
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" " + _toDisplayString($setup.t('common.buttons.sortDirections.descending')), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["static-id", "onClick"]))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.isColumnSorted(column))
                                                ? (_openBlock(), _createBlock($setup["EnMenuItem"], {
                                                    key: 2,
                                                    "static-id": $setup.buildId('reset-sort-column', column.key),
                                                    onClick: () => { $setup.resetSort(column); $setup.ensureMenuKey(column.key); $setup.closeMenu(column.key); }
                                                }, {
                                                    icon: _withCtx(() => [
                                                        _createVNode($setup["EnClearSortIcon"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" " + _toDisplayString($setup.t('common.dataGrid.clearSort')), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["static-id", "onClick"]))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.columnHasSortMenu(column) && ($setup.columnCanBeFiltered(column) || $setup.columnCanBeDeleted(column)))
                                                ? (_openBlock(), _createBlock($setup["MenuSeparator"], { key: 3 }))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.columnCanBeFiltered(column))
                                                ? (_openBlock(), _createBlock($setup["EnMenuItem"], {
                                                    key: 4,
                                                    class: "filter-bar-filter-open-button",
                                                    "static-id": $setup.buildId('filter-column', column.key),
                                                    onClick: () => { $props.toggleFilterVisibility(column); $setup.ensureMenuKey(column.key); $setup.closeMenu(column.key); }
                                                }, {
                                                    icon: _withCtx(() => [
                                                        _createVNode($setup["ListFilter"], { size: 15 })
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" " + _toDisplayString($setup.t('common.dataGrid.filter')), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["static-id", "onClick"]))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.columnCanBeFiltered(column) && $setup.columnCanBeDeleted(column))
                                                ? (_openBlock(), _createBlock($setup["MenuSeparator"], { key: 5 }))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.columnCanBeDeleted(column))
                                                ? (_openBlock(), _createBlock($setup["EnMenuItem"], {
                                                    key: 6,
                                                    "static-id": $setup.buildId('hide-column', column.key),
                                                    onClick: () => { $setup.remove(column.value); $setup.ensureMenuKey(column.key); $setup.closeMenu(column.key); }
                                                }, {
                                                    icon: _withCtx(() => [
                                                        _createVNode($setup["EyeOff"], { size: 15 })
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" " + _toDisplayString($setup.t('common.dataGrid.columnHide')), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["static-id", "onClick"]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "onUpdate:open"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(column.title), 1 /* TEXT */)
                                ]))
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    ($setup.columnIsCheckbox(column))
                        ? (_openBlock(), _createBlock($setup["EnCheckboxButton"], {
                            key: 2,
                            modelValue: $setup.allItemsSelected,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.allItemsSelected) = $event)),
                            indeterminate: $props.someSelected && !$props.allSelected,
                            "is-select-all": $props.allSelected,
                            id: "select-all",
                            class: "select-all-checkbox"
                        }, null, 8 /* PROPS */, ["modelValue", "indeterminate", "is-select-all"]))
                        : _createCommentVNode("v-if", true)
                ], 6 /* CLASS, STYLE */));
            }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "clone"]));
}
